import { REQUESTOR } from '../constants';

interface Site {
  siteId: string;
  domain: string;
  locales: {
    primary: string;
    supported: string[];
  };
}

export interface TenantData {
  tenant: string;
  sites: Site[];
}

const BASE_PATH = 'https://api.experience.cimpress.io/tenants/v1';

export default class TenantServiceClient {
  async getTenants(): Promise<TenantData[]> {
    const response = await fetch(`${BASE_PATH}/tenants?requestor=${REQUESTOR}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Error fetching tenants: ${response.status} ${response.statusText}`);
    }

    return response.json();
  }
}
